module.exports = __webpack_public_path__ + "media/images/favicon/favicon-120-cf46177ed46e611a985579627cafe52e.png";